import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSidenavModule } from "@angular/material/sidenav";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { FlexModule } from "@vp/shared/directives/flex";
import { DynamicTemplateModule } from "@vp/shared/directives/dynamic-template";
import { MaterialModule } from "@vp/shared/material";
import { MemoizePipeModule } from "@vp/shared/pipes/memoize";
import { SpinnerModule } from "@vp/shared/spinner";
import { ViewContentPageComponent } from "./view-content-page.component";

@NgModule({
  imports: [
    CommonModule,
    AngularEditorModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SpinnerModule,
    MemoizePipeModule,
    MatSidenavModule,
    DynamicTemplateModule,
    FlexModule
  ],
  declarations: [ViewContentPageComponent]
})
export class ViewContentPageModule {}
